import { observer } from "mobx-react-lite";
import { ConfirmEmptyTrashModal } from "@/pages/trash/ConfirmEmptyTrashModal";
import { MdsIconKind } from "@/design-system/components/icon";
import { DeleteNotesPermanentlyModal } from "@/components/modal/delete-notes-permanently/delete-notes-permanently-modal";
import { MdsPanelContainer } from "@/design-system/components/panel";
import { useTabPageStore } from "@/hooks/useTabPageStore";
import {
  MDSPanelHeader,
  MDSTextVariant,
  MDSPanelHeaderSlotName,
  MDSPanelHeaderButtonGroup,
  MDSIconButton,
  MDSTooltip,
  MDSTooltipPlacement,
  MDSText,
  MDSBanner,
  MDSBannerKind,
  MDSIconButtonSize,
} from "@/mds";
import { TrashPageList } from "@/pages/trash/TrashPageList";

interface TrashPageProps {}

export const TrashPage = observer<TrashPageProps>(function TrashPage() {
  const page = useTabPageStore("trashPage");
  page.listState.useListStateEffects();

  return (
    <>
      <DeleteNotesPermanentlyModal store={page.deleteNotePermanentlyModal} />
      <ConfirmEmptyTrashModal />

      <MDSPanelHeader>
        <MDSText
          slot={MDSPanelHeaderSlotName.Heading}
          variant={MDSTextVariant.HeaderXl}
          numberOfLines={1}
        >
          Trash
        </MDSText>
        <MDSPanelHeaderButtonGroup slot={MDSPanelHeaderSlotName.Actions}>
          <MDSTooltip config={{ label: "Empty trash", placement: MDSTooltipPlacement.Top }}>
            <MDSIconButton
              iconKind={MdsIconKind.Trash}
              onClick={page.openConfirmModal}
              size={MDSIconButtonSize.Medium}
            />
          </MDSTooltip>
        </MDSPanelHeaderButtonGroup>
      </MDSPanelHeader>
      <MDSBanner
        kind={MDSBannerKind.Default}
        iconKind={MdsIconKind.InfoCircle}
        message="Notes in trash are deleted after 30 days"
      />
      <MdsPanelContainer>
        <TrashPageList />
      </MdsPanelContainer>
    </>
  );
});
